import {
  BOXLESS,
  NARVAR_CONCIERGE,
  PRINTERLESS_MAIL,
  MAIL,
  STORE,
  HAPPY_RETURNS,
  CONCIERGE_PARTNERSHIP,
  LOCKER_DROPOFF,
} from './returnMethods';

export const CARRIERS_WITH_FEATURE_SORT = ['ups'];

export const STORE_SEARCH_LIMIT = 5;

export const RETURN_OPTIONS_THAT_REQUIRE_LOCATIONS = [
  NARVAR_CONCIERGE,
  CONCIERGE_PARTNERSHIP,
  PRINTERLESS_MAIL,
  BOXLESS,
  HAPPY_RETURNS,
  LOCKER_DROPOFF,
];

export const STORE_LOCATOR_DEFAULT_PARAMS = {
  [`${NARVAR_CONCIERGE}_fedex`]: [
    {
      key: 'brands',
      value: ['nordstrom', 'walgreens'],
    },
    {
      key: 'supportedactions',
      value: ['dropoff'],
    },
  ],
  [NARVAR_CONCIERGE]: [
    {
      key: 'supportedactions',
      value: ['dropoff'],
    },
  ],
  [`${PRINTERLESS_MAIL}_usps`]: [
    {
      key: 'carriers',
      value: ['usps'],
    },
    {
      key: 'supportedactions',
      value: ['dropoff'],
    },
  ],
  [PRINTERLESS_MAIL]: [
    {
      key: 'supportedactions',
      value: ['dropoff'],
    },
  ],
  [BOXLESS]: [
    {
      key: 'supportedactions',
      value: ['boxless'],
    },
  ],
  [`${BOXLESS}_ups`]: [
    {
      key: 'supportedactions',
      value: ['boxless'],
    },
  ],
  [MAIL]: [
    {
      key: 'supportedactions',
      value: ['dropoff'],
    },
  ],
  [STORE]: [
    {
      key: 'supportedactions',
      value: ['dropoff'],
    },
  ],
};
